import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3a7b5644"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "openboxlist"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "卡牌明细", -1));
const _hoisted_5 = {
  class: "box"
};
const _hoisted_6 = {
  class: "ul"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['unpacking_type', 'unpacking_type1'])
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "level"
};
const _hoisted_11 = {
  class: "name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BigImage = _resolveComponent("BigImage");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args))
  }), _hoisted_4])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      class: "li",
      key: idx
    }, [_createElementVNode("div", {
      class: "img",
      onClick: $event => $options.showBigImage(idx)
    }, [item.back_image_url ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 双面卡 ")) : _createCommentVNode("", true), _createElementVNode("img", {
      src: item.card_icon,
      alt: ""
    }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, _toDisplayString(item.level_name), 1)], 8, _hoisted_7), _createElementVNode("div", _hoisted_11, _toDisplayString(item.card_name), 1)]);
  }), 128))])]), _createElementVNode("div", {
    class: "bt",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toProject && $options.toProject(...args))
  }, "我的卡包"), _createVNode(_component_BigImage, {
    show: $data.bigImageVisible,
    init: $data.bigInitIndex,
    list: $data.img_list,
    onClose: _cache[2] || (_cache[2] = $event => $data.bigImageVisible = false)
  }, null, 8, ["show", "init", "list"])]);
}